import axios from 'axios'
import initReportsShow from './common/reports_show'
import { updateSearchParams } from '../common/search_params'

function selectedReportIds() {
  return $('.js-report-checkbox:checked').map((_i, v) => $(v).data('reportId')).toArray()
}

Styxie.Initializers.Reports = {
  index: () => {
    $(() => {
      $('.js-report-location-select, .js-report-configuration-select')
        .turboSelect({ width: '100%', dropdownAutoWidth: 'true' })
        .on('change', (e) => {
          const $el = $(e.currentTarget)
          const h = {}
          h[$el.prop('name')] = $el.val()
          updateSearchParams(h)
        })

      $('.js-reports-mark-all-checkbox').on('change', (e) => {
        const isChecked = $(e.currentTarget).is(':checked')
        $('.js-report-checkbox').prop('checked', isChecked).trigger('change')
      })

      $('.js-report-checkbox').on('change', () => {
        const isChecked = $('.js-report-checkbox').is(':checked')
        $('.js-open-reports-deletion-modal').prop('disabled', !isChecked)
      })

      $('.js-open-reports-deletion-modal').click((e) => {
        e.preventDefault()
        const ids = selectedReportIds()
        const { length } = ids

        if (length > 0) {
          const reportPluralTxt = length === 1 ? 'report' : 'reports'
          const msg = `You are going to delete ${length} ${reportPluralTxt}`
          swal({
            title: 'Are you sure?',
            text: msg,
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then((confirm) => {
            if (confirm) {
              axios.post('/reports/bulk_destroy', { report_ids: ids }).then(() => {
                window.location.reload()
              }).catch(() => {
                $('.js-delete-reports').prop('disabled', false)
              })
            }
          })
        }
      })
    })
  },
  show: initReportsShow
}
